export const chatTimeout = 3000;
export const code = "PP-UNP-ITA-1458";
